const cache = [];
function save(id, container) {
	if (container){
		cache[id] = container.scrollTop;
	}
}

function restore(id, container) {
	if (cache[id]) {
		container.scrollTop = cache[id];
		delete cache[id];
	}
}

export default { save, restore };



// WEBPACK FOOTER //
// ./mobile-core/src/utils/scroll-position.js